import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/como-funciona",
    name: "howitworks",
    redirect: "/ventas",
    component: () =>
      import(/* webpackChunkName: "como-funciona" */ "../views/HowWork.vue")
  },
  {
    path: "/ventas",
    name: "sales",
    component: () =>
      import(/* webpackChunkName: "ventas" */ "../views/Ventas.vue"),
    meta: {
      isHowItWorks: true,
      path: "Ventas",
      fondo: "venta"
    }
  },
  {
    path: "/cotizaciones",
    name: "marketrates",
    component: () =>
      import(
        /* webpackChunkName: "cotizaciones" */ "../views/Cotizaciones.vue"
      ),
    meta: {
      isHowItWorks: true,
      path: "Cotizaciones",
      fondo: "cotizacion"
    }
  },
  {
    path: "/guia-remision",
    name: "referralguide",
    component: () =>
      import(
        /* webpackChunkName: "guiaremision" */ "../views/GuiaRemision.vue"
      ),
    meta: {
      isHowItWorks: true,
      path: "Guías de Remisión",
      fondo: "remision"
    }
  },
  {
    path: "/cliente-proveedor",
    name: "client-provider",
    component: () =>
      import(
        /* webpackChunkName: "clientes-proveedores" */ "../views/ClientesProveedores.vue"
      ),
    meta: {
      isHowItWorks: true,
      path: "Clientes y Proveedores",
      fondo: "clientes"
    }
  },
  {
    path: "/gastos-compras",
    name: "expenses-purchases",
    component: () =>
      import(
        /* webpackChunkName: "gastos-compras" */ "../views/GastosCompras.vue"
      ),
    meta: {
      isHowItWorks: true,
      path: "Gastos y Compras",
      fondo: "gastos"
    }
  },
  {
    path: "/inventario",
    name: "inventory",
    component: () =>
      import(/* webpackChunkName: "inventario" */ "../views/Inventario.vue"),
    meta: {
      isHowItWorks: true,
      path: "Inventario",
      fondo: "inventario"
    }
  },
  {
    path: "/reportes",
    name: "reports",
    component: () =>
      import(/* webpackChunkName: "reportes" */ "../views/Reportes.vue"),
    meta: {
      isHowItWorks: true,
      path: "Reportes",
      fondo: "reporte"
    }
  },
  {
    path: "/planes",
    name: "plans",
    component: () =>
      import(/* webpackChunkName: "planes" */ "../components/TablePlan.vue")
  },
  {
    path: "/blog",
    name: "blog",
    component: () => import(/* webpackChunkName: "blog" */ "../views/Blog.vue"),
    meta: {
      isBlog: true
    }
  },
  {
    path: "/blog/:id",
    name: "blog-detail",
    component: () =>
      import(/* webpackChunkName: "blog-detail" */ "../views/BlogDetail.vue"),
    meta: {
      isBlog: true
    }
  },
  {
    path: "/contactanos",
    name: "contact",
    component: () =>
      import(/* webpackChunkName: "contactanos" */ "../views/Contactanos.vue")
  },
  {
    path: "/soporte",
    name: "support",
    component: () =>
      import(/* webpackChunkName: "soporte" */ "../views/Soporte.vue"),
    meta: {
      isSupport: true
    }
  },
  {
    path: "/soporte-list",
    name: "soporte",
    redirect: "/soporte-list/dashboard",
    component: () =>
      import(
        /* webpackChunkName: "soporte-detail" */ "../views/SoporteList.vue"
      ),
    meta: {
      isSupport: true
    },
    children: [
      {
        path: "/soporte-list/:id",
        name: "soporte-list",
        components: {
          default: () =>
            import(
              /* webpackChunkName: "soporte-detail" */ "../views/SoporteList.vue"
            ),
          soporte: () =>
            import(
              /* webpackChunkName: "soporte-dashboard" */ "../components/soporte/Dashboard.vue"
            )
        },
        meta: {
          isSupport: true,
          hasHeader: true
          // title: "Dashboard"
        }
      },
      {
        path: "/soporte-list/article/:slug",
        name: "soporte-article",
        components: {
          default: () =>
            import(
              /* webpackChunkName: "soporte-detail" */ "../views/SoporteList.vue"
            ),
          soporte: () =>
            import(
              /* webpackChunkName: "soporte-article" */ "../components/soporte/Article.vue"
            )
        },
        meta: {
          isSupport: true
        }
      }
    ]
  },
  {
    path: "/iso",
    name: "Iso",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "Iso" */ "../views/Iso.vue")
  },
  {
    path: "/libro-de-reclamaciones",
    name: "complains-book",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "complain-book" */ "../views/ComplainsBook.vue"
      )
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
